import PropertiesBrowser from 'components/admin/Properties/PropertiesBrowser'
import PropertiesEdit from 'components/admin/Properties/PropertiesEdit'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cancelConfirm } from 'redux/navigation'
import { loadProperties } from 'redux/properties'
import { Grid } from 'semantic-ui-react'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadProperties,
    },
    dispatch
  )
}

class Properties extends React.Component {
  componentWillMount() {
    const { loadProperties } = this.props
    loadProperties()
  }

  render() {
    return (
      <Grid columns={2} className="fullscreen-wrap">
        <Grid.Row>
          <Grid.Column
            computer={12}
            largeScreen={4}
            widescreen={3}
            className="stacked top up-to-computer">
            <PropertiesBrowser />
          </Grid.Column>
          <Grid.Column computer={12} largeScreen={8} widescreen={9}>
            <PropertiesEdit />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

Properties = connect(mapStateToProps, mapDispatchToProps)(Properties)
export default Properties



// WEBPACK FOOTER //
// ./src/containers/admin/properties.jsx